/** Message names the server sends to clients. */
export const SERVER_MESSAGE = {
    chat: "chat",
    combat: "combat",
    levelUp: "levelUp",
    abilityRejected: "abilityRejected",
};
//# sourceMappingURL=server.js.map